let uid = 0;

export default function uniqueId() {
  return uid++;
}
